<template>
	<div class="kun_loading65_container">
		<div class="div">
			<p id="h2">Loading....<span id="lol"></span></p>
		</div>
	</div>
</template>


<script>
	export default {
		name: "kun_loading65",
	}
</script>


<style scoped>
	.kun_loading65_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}


	#h2 {
		color: white;
		mix-blend-mode: difference; /* this will change color of loading  text      */
		text-align: center;
		margin: 0;
		font-size: 12px;
		line-height: 30px;
		font-family: Arial, Helvetica, sans-serif;
		text-shadow: 0 0 3px;
		padding: 0;
		letter-spacing: 5px;
	}

	.div {
		position: relative;
		top: 0;
		left: 0;
		max-width: 200px; /* Use viewport width for responsive width */
		width: 100%;
		height: 30px;
		background: linear-gradient(to right, white, black);
		background-size: 200% 100%;
		animation-delay: 2s;
		border-radius: 10px;
		box-shadow: 0 0 3px;
		-webkit-box-reflect: below 1px linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.4));
		animation: gradientAnimation 10s linear infinite reverse;
	}

	@keyframes gradientAnimation {
		0% {
			background-position: 0;
		}

		100% {
			background-position: 200% 0;
		}
	}

	/* Use media queries for responsiveness */
	@media (max-width: 768px) {
		.div {
			width: 500px; /* Adjust width for smaller screens */
			left: 10%;
		}
	}
</style>
